import React, { Component } from 'react';
import { formatoDecimal } from '../../../utilities/formatoNumeros'
import { switchCardEstado } from "../../../helper/publicacionHelper";
import { getFrontendConfig } from '../../../helper/frontendConfigHelper';
import { toast } from '../../../utilities/appToast';
import './PublicacionStyles.css';
import PropTypes from 'prop-types';

export default class PublicacionListItem extends Component {
    copyAlPortapapeles = async (e, valor, etiqueta) => {
        e.stopPropagation();
        if (valor === undefined || valor === null || valor === '') return;
        try {
            await navigator.clipboard.writeText(String(valor));
            toast.success(`${etiqueta} copiado`);
        } catch {
            toast.error('No se pudo copiar al portapapeles');
        }
    };

    render = () => {
        const {
            idPublicacion,
            titulo,
            skuSeller,
            skuMarket,
            categoria,
            precioLista,
            precioPromocional,
            estado,
            img,
            marca,
            envioGratis,
            handleEstado,
            tipoEntrega,
            fechaPublicacion,
            descripcionSeller,
            tipoPublicacion,
            stock,
            isAdminOrCategory,
            productoExceptuado,
            onOrdenes,
            hideCheckboxEstado,
            hideBtnOrdenes,
            descripcionUmbralStock
        } = this.props;

        // Aseguramos que sean strings para evitar error de React
        const marcaStr = typeof marca === 'object' && marca !== null ? (marca.descripcion ?? JSON.stringify(marca)) : marca;
        const categoriaStr = typeof categoria === 'object' && categoria !== null ? (categoria.descripcion ?? JSON.stringify(categoria)) : categoria;
        const tipoPublicacionStr = typeof tipoPublicacion === 'object' && tipoPublicacion !== null ? (tipoPublicacion.descripcion ?? JSON.stringify(tipoPublicacion)) : tipoPublicacion;
        const tipoEntregaStr = typeof tipoEntrega === 'object' && tipoEntrega !== null ? (tipoEntrega?.[0].descripcion ?? JSON.stringify(tipoEntrega)) : tipoEntrega;

        // Si el estado es string, lo convertimos a id
        let estadoId = estado;
        if (typeof estado === 'string') {
            // Importar el helper
            // eslint-disable-next-line
            const { getIdEstadoPublicacion } = require("../../../helper/publicacionHelper");
            estadoId = getIdEstadoPublicacion(estado);
        }
        const { text, color } = switchCardEstado(estadoId);
        const umbralNormalizado = String(descripcionUmbralStock ?? "").trim().toLowerCase();
        const stockNumerico = Number(stock);
        const stockEsNumero = Number.isFinite(stockNumerico);
        const stockConfig = getFrontendConfig()?.stockOptions ?? {};
        const umbralDesdeConfig = Number(stockConfig?.umbralStockBajo);
        const umbralStockBajo = Number.isFinite(umbralDesdeConfig) && umbralDesdeConfig >= 0
            ? umbralDesdeConfig
            : 3;

        let stockTier = "alto";
        if ((stockEsNumero && stockNumerico <= 0) || umbralNormalizado === "sin stock") {
            stockTier = "sin";
        } else if (umbralNormalizado === "stock bajo" || (stockEsNumero && stockNumerico <= umbralStockBajo)) {
            stockTier = "bajo";
        }

        let labelEstado =
            <div>
                <span className={`label label-item label-${color}`}>{text}</span>
            </div>
            ;

        const handleEstadoClick = (e) => {
            e.stopPropagation();
            handleEstado(e, { idPublicacion: idPublicacion, estado: estado, skuSeller: skuSeller, stock: stock });
        };

        let checkboxEstado =
            <span
                style={{ border: "none", background: "none", cursor: "pointer", display: "inline-block" }}
                className="custom-control form-switch"
                role="button"
                tabIndex={0}
                onClick={handleEstadoClick}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleEstadoClick(e); } }}
            >
                <input
                    id={idPublicacion}
                    type="checkbox"
                    className="form-check-input"
                    defaultChecked={estado === "activo"}
                    readOnly
                />
                <span htmlFor={idPublicacion} className="custom-control-label text-capitalize d-block">
                    <span className={`label label-item label-${color}`}>{text}</span>
                </span>
            </span>
            ;


        const handleOrdenesClick = (e) => {
            e.stopPropagation();
            onOrdenes(e, this.props.skuMarket);
        };

        let btnOrdenes =
            <div className='mt-2 font-14 applyFont'>
                <span
                    style={{ border: "none", background: "none", cursor: "pointer", display: "inline-block" }}
                    role="button"
                    tabIndex={0}
                    onClick={handleOrdenesClick}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleOrdenesClick(e); } }}
                    className="sl-icon-basket text-decoration-none fs-6 color-rojo-megatone me-1"
                >
                Ordenes
                </span>
            </div>

        return (
            <div className={`list-group-item publicacion-card publicacion-card--stock-${stockTier}`}>
                <div className="row p-2 align-items-center publicacion-card__inner">

                    <div className="col-8 col-md-2 text-center text-break">
                        <div className="displayInlineTable">
                            <h6 className="font-weight-bold">{descripcionSeller}</h6>
                            <span className="font-size-072rem">{fechaPublicacion ? fechaPublicacion.substr(0, 10) : ""}</span>
                            <br></br>
                            <span
                                className="font-size-072rem orden-copy-id"
                                role="button"
                                tabIndex={0}
                                title="Clic para copiar ID publicación"
                                onClick={(e) => this.copyAlPortapapeles(e, idPublicacion, 'ID publicación')}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, idPublicacion, 'ID publicación'); } }}
                            >
                                {idPublicacion}
                            </span>
                        </div>
                    </div>

                    <div className="col-4 col-md-1 text-center">
                        {img ? (
                            <img className="mw-60px" alt={titulo.substring(0, 10) + "..."} src={img} />
                        ) : (
                            <div className="mw-60px d-inline-block" style={{ width: 60, height: 60, background: '#f1f1f1', borderRadius: 4 }} aria-label="Sin imagen" />
                        )}
                    </div>

                    <div className="col-12 col-md-9 p-md-0 p-4">
                        <div className="row px-1">

                            <div className="col-12">
                                <h6 className="box-title m-b-5 font-weight-bold">
                                    <span
                                        className="orden-copy-id"
                                        role="button"
                                        tabIndex={0}
                                        title="Clic para copiar nombre del producto"
                                        onClick={(e) => this.copyAlPortapapeles(e, titulo, 'Nombre del producto')}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, titulo, 'Nombre del producto'); } }}
                                    >
                                        {titulo}
                                    </span>
                                </h6>
                            </div>

                            <div className="col-12 col-md-6 pb-lg-0 pb-md-0 pb-4">
                                <small className="applyFont">{marcaStr} - {categoriaStr}</small>
                                <small className="d-block mt-1">
                                    SKU Seller:
                                    {" "}
                                    <span
                                        className="orden-copy-id"
                                        role="button"
                                        tabIndex={0}
                                        title="Clic para copiar SKU seller"
                                        onClick={(e) => this.copyAlPortapapeles(e, skuSeller, 'SKU seller')}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, skuSeller, 'SKU seller'); } }}
                                    >
                                        {skuSeller}
                                    </span>
                                    {" "} | SKU Market:
                                    {" "}
                                    <span
                                        className="orden-copy-id"
                                        role="button"
                                        tabIndex={0}
                                        title="Clic para copiar SKU market"
                                        onClick={(e) => this.copyAlPortapapeles(e, skuMarket, 'SKU market')}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, skuMarket, 'SKU market'); } }}
                                    >
                                        {skuMarket}
                                    </span>
                                </small>
                                <small className="d-block mt-1">
                                    <b>Tipo publicación: </b>{tipoPublicacionStr}
                                </small>
                                <div className="mt-1">
                                    {(() => {
                                        let stockClass = "stock-alto";
                                        let stockText = "Stock Alto";

                                        if ((stockEsNumero && stockNumerico <= 0) || umbralNormalizado === "sin stock") {
                                            stockClass = "sin-stock";
                                            stockText = "Sin Stock";
                                        } else if (umbralNormalizado === "stock bajo" || (stockEsNumero && stockNumerico <= umbralStockBajo)) {
                                            stockClass = "stock-bajo";
                                            stockText = "Stock Bajo";
                                        }

                                        return (
                                            <span className={`stock-indicator ${stockClass}`}>
                                                Stock: {stock} — {stockText}
                                            </span>
                                        );
                                    })()}
                                </div>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <small className="font-14 applyFont">
                                    {tipoEntregaStr ?? ""}
                                </small>
                                <br />
                                <small className="font-14 applyFont">
                                    {(envioGratis) ? "Envio Gratis" : ""}
                                </small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                <h6 className="font-weight-bold box-title m-b-0">
                                    $
                                    {" "}
                                    <span
                                        className="orden-copy-id"
                                        role="button"
                                        tabIndex={0}
                                        title="Clic para copiar precio publicado"
                                        onClick={(e) => this.copyAlPortapapeles(e, (precioPromocional || precioLista), 'Precio')}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.copyAlPortapapeles(e, (precioPromocional || precioLista), 'Precio'); } }}
                                    >
                                        {(precioPromocional) ? formatoDecimal(precioPromocional) : formatoDecimal(precioLista)}
                                    </span>
                                </h6>
                                <small className="font-size-10px">Precio Publicado</small>
                            </div>

                            <div className="col-4 col-md-2 text-center">
                                {/* Si está oculto el switch, muestra solo el label de estado */}
                                {hideCheckboxEstado && labelEstado}
                                {!hideCheckboxEstado && (isAdminOrCategory ? checkboxEstado : labelEstado)}
                                {isAdminOrCategory && productoExceptuado &&
                                    <small className="label label-item label-red mt-1 p-1">
                                        PRODUCTO <br /> EXCEPTUADO
                                    </small>
                                }
                                {/* Oculta el botón de órdenes si hideBtnOrdenes es true */}
                                {!hideBtnOrdenes && btnOrdenes}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
PublicacionListItem.propTypes = {
    idPublicacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    titulo: PropTypes.string,
    skuSeller: PropTypes.number,
    skuMarket: PropTypes.number,
    categoria: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    precioLista: PropTypes.string,
    precioPromocional: PropTypes.string,
    estado: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    img: PropTypes.string,
    marca: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    envioGratis: PropTypes.bool,
    handleEstado: PropTypes.func,
    tipoEntrega: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    fechaPublicacion: PropTypes.string,
    descripcionSeller: PropTypes.string,
    tipoPublicacion: PropTypes.shape({
        descripcion: PropTypes.string,
    }),
    stock: PropTypes.number,
    isAdminOrCategory: PropTypes.bool,
    productoExceptuado: PropTypes.bool,
    onOrdenes: PropTypes.func,
    hideCheckboxEstado: PropTypes.bool,
    hideBtnOrdenes: PropTypes.bool,
    descripcionUmbralStock: PropTypes.string,
}